import React, { useRef, useState } from 'react'
import { OfferBlock, OfferBlockSpacer } from '../../models/shared/Offer'
import BlockToolbar, { SpacerSizePicker } from './BlockToolbar'

interface Props {
    block: OfferBlock;
    readOnly?: boolean;
    onBlockUpdate: (updatedBlock: OfferBlock) => void;
    onBlockDelete: () => void;
    onMoveUp?: () => void;
    onMoveDown?: () => void;
}

export default function BlockSpacer(props: Props) {
    const { block: generalBlock, onBlockUpdate, onBlockDelete } = props;
    const block = generalBlock as OfferBlockSpacer;
    const [showToolbar, setShowToolbar] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    // Simple size heights
    const sizeHeights = {
        small: '24px',
        medium: '48px',
        large: '96px',
    };
    const handleBlockUpdate = (update: Partial<OfferBlockSpacer>) => {
        const updatedBlock = {
            ...block,
            ...update
        };
        onBlockUpdate(updatedBlock);
    };

    return (
        <div
            ref={contentRef}
            className="position-relative w-100"
            onClick={() => !props.readOnly && setShowToolbar(true)}
            style={{
                cursor: props.readOnly ? 'default' : 'pointer'
            }}
        >
            <BlockToolbar
                contentRef={contentRef}
                onDelete={onBlockDelete}
                onMoveUp={props.onMoveUp}
                onMoveDown={props.onMoveDown}
                showToolbar={showToolbar}
                setShowToolbar={setShowToolbar}
                readOnly={props.readOnly}
            >
                <SpacerSizePicker
                    value={block.size || 'medium'}
                    onChange={(size) => handleBlockUpdate({ size })}
                />
            </BlockToolbar>

            <div
                className="spacer-block"
                style={{
                    height: sizeHeights[block.size || 'medium'],
                    width: '100%',
                    borderRadius: '4px',
                    border: showToolbar ? '1px dashed #adb5bd' : 'none'
                }}
            />
        </div>
    );
}
